import React from "react";
import ReactDOM from "react-dom/client";
import AiNativeVsBoltOn from "./ai-native-vs-bolt-on";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiNativeVsBoltOn />
  </React.StrictMode>,
);
